import { render, staticRenderFns } from "./DepartmentChildrenList.vue?vue&type=template&id=50070938&scoped=true"
import script from "./DepartmentChildrenList.vue?vue&type=script&lang=js"
export * from "./DepartmentChildrenList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentChildrenList.vue?vue&type=style&index=0&id=50070938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50070938",
  null
  
)

export default component.exports